
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiEsperienzePunteggiDialog extends Serenity.EntityDialog<ProdottiEsperienzePunteggiRow, any> {
        protected getFormKey() { return ProdottiEsperienzePunteggiForm.formKey; }
        protected getIdProperty() { return ProdottiEsperienzePunteggiRow.idProperty; }
        protected getLocalTextPrefix() { return ProdottiEsperienzePunteggiRow.localTextPrefix; }
        protected getNameProperty() { return ProdottiEsperienzePunteggiRow.nameProperty; }
        protected getService() { return ProdottiEsperienzePunteggiService.baseUrl; }
        protected getDeletePermission() { return ProdottiEsperienzePunteggiRow.deletePermission; }
        protected getInsertPermission() { return ProdottiEsperienzePunteggiRow.insertPermission; }
        protected getUpdatePermission() { return ProdottiEsperienzePunteggiRow.updatePermission; }

        protected form = new ProdottiEsperienzePunteggiForm(this.idPrefix);

    }
}